import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";

const Previewvideo = () => {
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  const navigate = useNavigate();
  const { id, id2 } = useParams();
  const { contextData } = useContext(AuthContext);

  const downloadFile = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/video/${id2}/`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    const videoPlayer = document.getElementById("video-player");
    const videoUrl = URL.createObjectURL(new Blob([responce.data]));
    if (videoPlayer) {
      videoPlayer.src = videoUrl;
    }
  };

  useEffect(() => {
    downloadFile();
  }, []);

  return (
    <div className="video-bigcontainer ">
      <div>
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}
      </div>

      <div className="video-display-container">
        <video id="video-player" className="videofile" controls></video>
      </div>
    </div>
  );
};

export default Previewvideo;
